import { Tile, Container, Header, Flyer, CustomizeForm, BodyText } from "../components/";
import * as templates from "../../../assets/flyers";
import * as React from "react";
import { getLastUrlSegmentOf } from "../../../utilities/getLastUrlSegmentOf";

export const Form = props => (
  <div>
    <Header>Please fill Out the form</Header>
    <BodyText animation={"fadeIn"}> 
        Home stretch! 🏁
    </BodyText>
    <Container tight animation={"fadeIn delay"}>
      <Tile route={""}>
        <Flyer size={"medium"}>
          {templates[getLastUrlSegmentOf(props.route)]}
        </Flyer>
      </Tile>
      <CustomizeForm />
    </Container>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/marketing/pages/form.js